(function() {

  function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    try {
      localStorage.setItem(key, JSON.stringify(item));
      console.log('Saved preference:', key, value, 'TTL:', ttl);
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  function getMsUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime() - now.getTime();
  }

  function handleCountrySelection() {
    const dropdown = document.getElementById('country-dropdown');
    const selectedDisplay = dropdown ? dropdown.querySelector('.dropdown-selected') : null;
    const selectedText = dropdown ? dropdown.querySelector('.selected-text') : null;
    const items = dropdown ? dropdown.querySelectorAll('.dropdown-list li') : [];
    const continueBtn = document.getElementById('continue-btn');
    const rememberCheckbox = document.getElementById('remember-selection');
    const cookieBtn = document.getElementById('cookie-settings');

    if (!dropdown || !continueBtn) {
      console.error('Required elements not found');
      return;
    }

    // Default selection
    let currentSelection = selectedDisplay.getAttribute('data-value') || 'PK';

    // Toggle Dropdown
    selectedDisplay.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    // Close on outside click
    document.addEventListener('click', function() {
      dropdown.classList.remove('open');
    });

    // Handle Item Selection
    items.forEach(item => {
      item.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent closing immediately/bubbling
        const val = this.getAttribute('data-value');
        const text = this.textContent.trim();
        
        // Update Display
        if (selectedText) selectedText.textContent = text;
        selectedDisplay.setAttribute('data-value', val);
        currentSelection = val;
        
        // Update active class
        items.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
        
        dropdown.classList.remove('open');
      });
    });

    // Handle Continue Click
    continueBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const countryCode = currentSelection;
      
      // Determine Expiry
      const isRemembered = rememberCheckbox && rememberCheckbox.checked;
      // 14 days or until midnight
      const ttl = isRemembered ? (14 * 24 * 60 * 60 * 1000) : getMsUntilMidnight();
      
      // Save preference (save the code or name, 'UK' is default fallback logic in old script but we can save code now)
      setWithExpiry('unze-selected-country', countryCode, ttl);

      // Redirect Map
      const urls = {
        'UK': 'https://unze.co.uk/',
        'DE': 'https://www.unze.de.com/',
        'US': 'https://unze.us/',
        'FR': 'https://www.unzelondon.fr/',
        'PK': 'https://unze.com.pk/'
      };

      const targetUrl = urls[countryCode] || urls['PK'];
      
      // Add skip parameter to avoid loops if target has similar logic (though logic is domain restricted now)
      // We adding param just to be safe and consistent with previous logic
      const sep = targetUrl.includes('?') ? '&' : '?';
      const finalUrl = `${targetUrl}${sep}skip_country_check=true`;

      console.log(`Redirecting to ${countryCode}: ${finalUrl}`);
      window.location.href = finalUrl;
    });

    // Cookie Settings Button Logic (Custom Modal)
    if (cookieBtn) {
      const modal = document.getElementById('custom-cookie-modal');
      const closeBtn = modal ? modal.querySelector('.cookie-close-btn') : null;
      const saveBtn = modal ? modal.querySelector('.cookie-save-btn') : null;
      const acceptBtn = modal ? modal.querySelector('.cookie-accept-btn') : null;
      const analyticsInfo = modal ? modal.querySelector('#consent-analytics') : null;
      const marketingInfo = modal ? modal.querySelector('#consent-marketing') : null;

      // Open Modal
      cookieBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (modal) {
          modal.classList.add('visible');
          // Load saved state if exists
          const savedConsent = JSON.parse(localStorage.getItem('unze-cookie-consent') || '{}');
          if (analyticsInfo) analyticsInfo.checked = savedConsent.analytics !== false; // Default true
          if (marketingInfo) marketingInfo.checked = savedConsent.marketing !== false; // Default true
        }
      });

      // Close Modal Function
      const closeModal = () => {
        if (modal) modal.classList.remove('visible');
      };

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      
      // Close on outside click
      if (modal) {
        modal.addEventListener('click', function(e) {
          if (e.target === modal) closeModal();
        });
      }

      // Save Preferences
      if (saveBtn) {
        saveBtn.addEventListener('click', function() {
          const consent = {
            analytics: analyticsInfo ? analyticsInfo.checked : true,
            marketing: marketingInfo ? marketingInfo.checked : true,
            timestamp: new Date().getTime()
          };
          localStorage.setItem('unze-cookie-consent', JSON.stringify(consent));
          console.log('Cookie preferences saved:', consent);
          closeModal();
        });
      }

      // Accept All
      if (acceptBtn) {
        acceptBtn.addEventListener('click', function() {
          if (analyticsInfo) analyticsInfo.checked = true;
          if (marketingInfo) marketingInfo.checked = true;
          
          const consent = {
            analytics: true,
            marketing: true,
            timestamp: new Date().getTime()
          };
          localStorage.setItem('unze-cookie-consent', JSON.stringify(consent));
          console.log('All cookies accepted');
          closeModal();
        });
      }

      // Decline All
      const declineBtn = modal ? modal.querySelector('.cookie-decline-btn') : null;
      if (declineBtn) {
        declineBtn.addEventListener('click', function() {
          if (analyticsInfo) analyticsInfo.checked = false;
          if (marketingInfo) marketingInfo.checked = false;
          
          const consent = {
            analytics: false,
            marketing: false,
            timestamp: new Date().getTime()
          };
          localStorage.setItem('unze-cookie-consent', JSON.stringify(consent));
          console.log('Optional cookies declined');
          closeModal();
        });
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCountrySelection);
  } else {
    handleCountrySelection();
  }
})();